import { useTranslation } from 'react-i18next';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { useCustomParamId } from 'hooks/useParamId';
import i18next from 'i18next';
import { eventCashFlowQueryToForm } from 'middleware/event-cash-flow';
import { PiPencilSimpleLine, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteEventCost, useGetEventCost } from 'services/events/cost';

const EventCost = () => {
  const { t } = useTranslation();
  const eventCostId = useCustomParamId('eventCostId');
  const { pathname } = useLocation();
  const { isPending, mutateAsync } = useDeleteEventCost();

  const navigate = useNavigate();

  const { data: eventCost, isLoading } = useGetEventCost(eventCostId);

  const handleDeleteEventCost = async () => {
    await mutateAsync({ eventCostId }, {
      onSuccess: () => navigate(`/event/${eventCost?.eventId}/balance`),
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-cost'
      initialValues={
        eventCost ? eventCashFlowQueryToForm(eventCost, 'cost') : eventCashFlowInitialValues
      }
      onSubmit={() => {}}
      tittle={eventCost?.costName ?? i18next.t('event-cost.title.individual')}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate(`/event/${eventCost?.eventId}/balance`)}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      status={{ displayMode: true, isLoading }}
      topbarContent={
        <div className='flex gap-2 items-center'>
            <Button
              isClear
              onlyIcon
              onClick={() => {
                eventCost &&
                  navigate(`/event/${eventCost.eventId}/cost/edit/${eventCostId}`, {
                    replace: true,
                  });
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
            <MagellanPopups.DeleteWarning
              onRemove={handleDeleteEventCost}
              removeLoading={isPending}
              name={eventCost?.costName}
            />
        </div>
      }
    />
  );
};

export default EventCost; 